import { render, staticRenderFns } from "./PopsReceiveAuthCode.vue?vue&type=template&id=6570391a"
import script from "./PopsReceiveAuthCode.vue?vue&type=script&lang=js"
export * from "./PopsReceiveAuthCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports